import { render, staticRenderFns } from "./boards_selector.vue?vue&type=template&id=678e2202&"
import script from "./boards_selector.vue?vue&type=script&lang=js&"
export * from "./boards_selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "boards_selector.vue"
export default component.exports